import React from 'react';
import PropTypes from 'prop-types';
import { 
  FormGroup,
  Input,
  FormFeedback,
  FormText,
} from "reactstrap";

const CustomInput = ({ 
  id,
  labelText,
  helpText,
  type,
  formGroupProps,
  labelProps,
  inputProps = {},
  input = {},
  meta,
}) => {
  const newId = input && input.name ? input.name : id;
  const errorMsg = meta && meta.touched && meta.error;
  if( meta && meta.touched ) {
    if( meta.invalid ) inputProps.invalid = true;
    if( meta.valid ) inputProps.valid = true;
  }

  const { value, ...fileInputProps } = input;
  if( type === "file" ) {
    input = { ...fileInputProps }
  }

  return (
    <FormGroup {...formGroupProps} >
      {labelText !== undefined && (
        <label
          className="form-control-label"
          htmlFor={newId}
          {...labelProps}
        >
        {labelText}
        </label>
      )}
      <Input
        id={newId}
        type={type}
        {...inputProps}
        {...input}
      />
      {errorMsg && <FormFeedback>{errorMsg}</FormFeedback>}
      {!errorMsg && helpText && <FormText>{helpText}</FormText>}
    </FormGroup>
  );
};


CustomInput.propTypes = {
  id: PropTypes.string,
  labelText: PropTypes.string,
  helpText: PropTypes.string,
  type: PropTypes.string.isRequired,
};

export default CustomInput;